import {cloneDeep} from 'lodash'

export default {
  namespaced: true,

  state: {
    showOriginalUpload: false,
    showSignedUpload: false,

    soldto: null,
    soldtoIds: [],
    attachments: [],
    updated: false,
  },
  getters: {},
  mutations: {
    showOriginalUpload: (s, b) => {
      s.showOriginalUpload = b
      if (!b) {
        s.soldtoIds = []
        s.attachments = []
      }
    },
    showSignedUpload: (s, b) => {
      s.showSignedUpload = b
      if (!b) {
        s.soldtoIds = []
        s.attachments = []
      }
    },
    soldto: (s, o) => (s.soldto = cloneDeep(o)),
    soldtoIds: (s, a) => (s.soldtoIds = a),
    attachments: (s, a) => (s.attachments = a),

    addAttachment: (s, o) => {
      const i = s.attachments.findIndex((x) => x.name == o.name)

      if (i < 0) s.attachments.push(o)
    },
    removeAttachment: (s, v) => {
      const i = s.attachments.findIndex((f) => f.name == v)

      if (i >= 0) s.attachments.splice(i, 1)
    },
    updated: (s, b) => (s.updated = b),
  },
  actions: {},
}
